import firebase from '../../firebase';

const learnImportMapping = (data) => firebase.functions().httpsCallable('rides-learnImportMapping')(data);

export default learnImportMapping;
